import {createModel} from '@rematch/core';

import {refreshCaptca} from '~/utils/captcha';
import {RemovalRequestFormValues} from '~/modals/RemovalRequestModal/parts/RemovalRequestForm';
import {REMOVAL_REQUEST_CAPTCHA_ID} from '~/modals/constants';
import {postRemovalRequest} from '~/services/publicForm';

import type {RootModel} from '../index';

export type RemovalRequestState = {
  success: boolean | string;
  error: boolean;
  errorCaptcha: boolean;
};

const defaultState: RemovalRequestState = {
  success: false,
  error: false,
  errorCaptcha: false,
};

export const removalRequest = createModel<RootModel>()({
  state: defaultState,
  reducers: {
    setRemovalRequestSuccess: (state, success: string | boolean) => ({
      ...state,
      success,
    }),
    setRemovalRequestError: (state, error: boolean) => ({
      ...state,
      error,
    }),
    setRemovalRequestErrorCaptcha: (state, errorCaptcha: boolean) => ({
      ...state,
      errorCaptcha,
    }),
    setRemovalRequestDefaultState: (state, payload = defaultState) => ({
      ...state,
      ...payload,
    }),
  },
  effects: (dispatch) => {
    return {
      async removalRequestSave(data: RemovalRequestFormValues): Promise<void> {
        dispatch.removalRequest.setRemovalRequestDefaultState();

        try {
          const response = await postRemovalRequest(data);

          if (response.status === 204) {
            dispatch.removalRequest.setRemovalRequestSuccess(true);
          } else if (response?.data?.error?.message.includes('captcha')) {
            dispatch.removalRequest.setRemovalRequestErrorCaptcha(true);
            refreshCaptca(`#${REMOVAL_REQUEST_CAPTCHA_ID}`);
          } else {
            dispatch.removalRequest.setRemovalRequestError(true);
          }
        } catch (error: any) {
          console.error(error);

          if (error?.response?.data?.error?.message.includes('captcha')) {
            dispatch.removalRequest.setRemovalRequestErrorCaptcha(true);
          } else {
            dispatch.removalRequest.setRemovalRequestError(true);
          }

          refreshCaptca(`#${REMOVAL_REQUEST_CAPTCHA_ID}`);
        }
      },
    };
  },
});
